import { rosterProviderTypeChips } from '../../services/roster/roster.filters';
import type { RosterTab } from '../../services/roster/roster.types';
import { RosterStore } from '../../stores/roster/roster.store';
import { TypeCountBadge, TypeFilterBar, TypeFilterChip } from '../base/type-filter-bar/type-filter-bar';
import { observer } from 'mobx-react';
import React from 'react';
import * as S from './roster-page.styles';

interface IRosterFiltersProps {
    store: RosterStore;
}

/** Shown in place of a count that has not loaded or failed to — never `0`, which says there are none (NS-3). */
const UNKNOWN = '—';

/** The Providers / Facilities tabs, and — on Providers — the provider-type chips. */
export const RosterFilters = observer(({ store }: IRosterFiltersProps): React.ReactElement => {
    const counts = store.typeCounts;

    return (
        <>
            <S.Tabs<RosterTab>
                tabs={[
                    { id: 'providers', label: 'Providers', count: store.tabCounts.providers ?? UNKNOWN },
                    { id: 'facilities', label: 'Facilities', count: store.tabCounts.facilities ?? UNKNOWN },
                ]}
                activeTab={store.tab}
                onTabChange={store.setTab}
            />
            {store.tab === 'providers' && (
                <S.TypeRow>
                    <S.TypeLabel>Provider type</S.TypeLabel>
                    <TypeFilterBar>
                        <TypeFilterChip
                            active={store.providerType === undefined}
                            onClick={(): void => store.setProviderType(undefined)}
                        >
                            All
                            <TypeCountBadge active={store.providerType === undefined}>
                                {counts ? counts.total : UNKNOWN}
                            </TypeCountBadge>
                        </TypeFilterChip>
                        {rosterProviderTypeChips(counts).map(type => (
                            <TypeFilterChip
                                key={type}
                                active={store.providerType === type}
                                onClick={(): void => store.setProviderType(type)}
                            >
                                {type}
                                <TypeCountBadge active={store.providerType === type}>
                                    {counts ? (counts.byType[type] ?? 0) : UNKNOWN}
                                </TypeCountBadge>
                            </TypeFilterChip>
                        ))}
                    </TypeFilterBar>
                </S.TypeRow>
            )}
        </>
    );
});
